import { types, getParent, type Instance } from 'mobx-state-tree';
import Method from './method';
import { modelReference } from '../refHelper';
import type { ITransition } from './transition';

/**
 * A method in a MERODE FSM Transition
 */
const TransitionMethod = types
  .model('TransitionMethod', {
    id: types.identifier,
    method: types.maybeNull(modelReference(Method)),
    methodName: types.maybeNull(types.string),
  })
  .views(self => ({
    // Convenience method to get the transition
    get transition(): ITransition {
      return getParent(self, 2);
    },
  }));

export type ITransitionMethod = Instance<typeof TransitionMethod>;

export default TransitionMethod;
